import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { selectChallengeById, setEditId } from "../../../store/mine_craft/challengesSlice";
import { destroyChallenge, fetchChallenge } from "../../../actions/mine_craft/challengesActions";
import { fetchCategories } from "../../../actions/mine_craft/categoriesActions";
import minecraftUrls from "../../../configs/mine_craft/minecraftUrls";

import { AppstoreOutlined, LikeOutlined, MessageOutlined, StarOutlined } from "@ant-design/icons";
import { Image, message } from "antd";
import Tabs from "../../../componets/Tabs";
import PageLayout from "../_partials/PageLayout";
import IconText from "src/componets/IconText";
import StatsIcons from "src/componets/StatsIcons";
import Edit from "./Edit";
import SummaryShow from "src/componets/SummaryShow";
import SidebarShow from "./_partials/_SidebarShow";
import Details from "./_partials/_Details";
import Comments from "./_partials/_Comments";
import EditComment from "../Comments/Edit";
import { ButtonDestroy, ButtonEdit } from "../../../componets/Buttons";
import usePermissions from "src/hooks/usePermissions";

const TARGET_ID = 1;

const Show: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const challenge = useAppSelector(state => id ? selectChallengeById(state, id) : undefined);
  const { write_minecraft } = usePermissions();

  useEffect(() => {
    if (id) {
      dispatch(fetchCategories({ target_id: TARGET_ID }));
      dispatch(fetchChallenge(id));
    }
  }, [id, dispatch]);

  function onClickEdit() {
    if (challenge) {
      dispatch(setEditId(challenge.id));
    }
  }

  function onClickDestroy() {
    if (challenge) {
      handleDestroy(challenge.id).catch(console.error);
    }
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyChallenge(id));

    if (destroyChallenge.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(minecraftUrls.challengesPath()), 1000);
    }

    if (destroyChallenge.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  return (
    <PageLayout className='v-challenges-show'>
      <div className='v-container-fluid'>
        <div className='o-header'>
          {
            challenge &&
              <SummaryShow
                title={challenge.title}
                subtitle={challenge.subtitle}
                image={challenge.thumbnail_url}
                dateName1='Start at'
                dateName2='End at'
                createdAt={challenge.start_at}
                updatedAt={challenge.end_at}
                className='v-mb-15'
                actions={write_minecraft ? [
                  <ButtonEdit key='button-edit' onClick={onClickEdit} />,
                  <ButtonDestroy key='button-destroy' onClick={onClickDestroy} />
                ] : []}
              />
          }

          <StatsIcons
            icons={[
              <Image src={challenge?.ico_url} width={14} height={14} preview={false} style={{ marginTop: -4 }}/>,
              <IconText tooltip='posts' icon={AppstoreOutlined} text={challenge?.addons_count} />,
              <IconText tooltip='popular' icon={StarOutlined} text={challenge?.popular_count} />,
              <IconText tooltip='likes' icon={LikeOutlined} text={challenge?.likes_count} />,
              <IconText tooltip='comments' icon={MessageOutlined} text={challenge?.comments_count} />
            ]}
          />
        </div>

        <Tabs
          paramsKey='tab'
          items={[
            { label: 'Details', key: 'details', children: <Details challenge={challenge} /> },
            { label: 'Comments', key: 'comment', children: <Comments challengeId={challenge?.id} /> }
          ]}
        />
      </div>

      <SidebarShow challenge={challenge} />

      <Edit />

      <EditComment />
    </PageLayout>
  )
}

export default Show;
